import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export default class Bars extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tipo_id: this.props.match.params.id,
      barras: [],
      user: JSON.parse(localStorage.getItem('tpuser'))
    };
  }

  componentDidMount() {
    this.userData();
  }

  userData() {
    fetch(process.env.REACT_APP_API_URL + '/users/me', {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + this.state.user.token
      }
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({ user: data }, () => {
          const myResult = this.state.user.results
            ? this.state.user.results[this.state.user.results.length - 1]
            : false;
          const myPerso = myResult.data.result.join('');
          const myIdentity = myResult.data.identity;
          const myBars = myResult.data.result.map((r) => {
            let leftCat = myResult.data.total.find(
              (cat) => cat.category.code == r
            );
            let rightCat = myResult.data.total.find(
              (cat) => cat.category_vs.code == r
            );

            let finalCat = { name: '...' };
            if (leftCat) {
              finalCat.left = leftCat.category.name;
              finalCat.value = parseInt(leftCat.category.avg);
              finalCat.right = leftCat.category_vs.name;
            } else {
              finalCat.left = rightCat.category.name;
              finalCat.value = parseInt(rightCat.category.avg);
              finalCat.right = rightCat.category_vs.name;
            }

            return finalCat;
          });

          fetch(
            process.env.REACT_APP_API_URL + '/type/' + myPerso.toUpperCase(),
            {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json'
              }
            }
          )
            .then((response) => {
              return response.json();
            })
            .then((data) => {
              console.log({ data });

              data.barras = myBars;
              data.identity = myIdentity;
              this.setState(data);
            });
        });
      })
      .catch((err) => console.log(err));
  }

  render() {
    let barras = this.state.barras.map((b, bi) => {
      return (
        <div key={'barras-' + bi} className="b-bottom margin-top-30">
          {/* <span className="font-20">{b.name} <i className="fas fa-long-arrow-alt-right"></i></span> */}
          <div className="col-12 col-sm-12 padding-0">
            <p className="margin-0">{b.left}</p>
            <p className="margin-0 text-right margin-top-23">{b.right}</p>
            <div className="progress">
              <div
                className="progress-bar progress-bar-success"
                role="progressbar"
                style={{ width: b.value + '%' }}>
                <span>{b.value}%</span>
              </div>
            </div>
          </div>
          <p className="margin-top-10">{this.state.dato}</p>
        </div>
      );
    });

    const sex = this.state.user.sex == 'female' ? 'F' : 'M';

    return (
      <div className="container">
        <div className="row">
          <div className="col-sm-5 offset-sm-1">
            <img
              src={'/img-tipos/' + this.state.code + '_' + sex + '.svg'}
              className="img-responsive d-none d-sm-block"
            />
          </div>
          <div className="col-sm-5 col-xs-12">
            <p className="margin-0 media-center">Tu resultado es:</p>
            <h1 className="title media-center">{this.state.name}</h1>
            <h2 className=" media-center">
              <b>
                {this.state.code} / {this.state.identity}
              </b>
            </h2>
            <img
              src={'/img-tipos/' + this.state.code + '_' + sex + '.svg'}
              className="img-30 d-block d-sm-none img-center"
            />

            {barras}

            {/* <div className="margin-top-30 font-20">
                <span>Identidad <i className="fas fa-long-arrow-alt-right"></i></span>
                <p className="margin-top-10">{this.state._code}</p>
              </div> */}
            <Link
              to={'/bars/' + this.state.code + '/descripcion'}
              className="btn btn-lg btn-black margin-top-30">
              Leer descripción
            </Link>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Bars.jsx